import hrApi from '../../api/hr'
import shiftApi from '../../api/shift'
import moment from 'moment'

// initial state
const state = {
  filters: {
    managers: [
    ],
    positions: [
    ],
    skills: [
    ],
    locations: [
    ],
    statuses: [
    ],
  },
  workHistory: [
  ],
  workHistoryStats: {
  },
  workHistoryPaged: [
  ],
  workHistoryStatsPaged: {
  },
  schedule: [
  ],
}

const getters = {
}

const actions = {
  getFilters ({ commit }, userId) {
    hrApi.getFilters(userId, filters => {
      commit('setFilters', filters)
    })
  },

  getWorkHistory ({ commit }, params) {
    return new Promise((resolve) => {
      shiftApi.getWorkHistory(params, shifts => {
        commit('setWorkHistory', shifts)
        resolve(shifts)
      })
    })
  },

  getWorkHistoryPaged ({ commit }, params) {
    return new Promise((resolve) => {
      shiftApi.getWorkHistory(params, shifts => {
        commit('setWorkHistoryPaged', shifts)
        resolve(shifts)
      })
    })
  },

  getStats ({ commit }, params) {
    return new Promise((resolve) => {
      hrApi.getEmployeeStats(params, stats => {
        // commit('setWorkHistory', shifts)
        resolve(stats)
      })
    })
  },

  getSchedule ({ commit }, userId) {
    return new Promise((resolve) => {
      shiftApi.getUpcomingFor (userId, shifts => {
        commit('setSchedule', shifts)
        resolve()
      })
    })
  },
}

const mutations = {
  setFilters (state, filters) {
    state.filters = filters
    //state.available = Object.assign({}, state.available, shifts) // Works...
    //Object.assign(state.available, shifts) // NO! doesn't work!
  },

  setWorkHistory (state, shifts) {
    state.workHistory = shifts.shifts
    state.workHistoryStats = shifts.stats
  },

  setWorkHistoryPaged (state, shifts) {
    state.workHistoryPaged = shifts.shifts
    state.workHistoryStatsPaged = shifts.stats
  },

  setSchedule (state, shifts) {
    state.schedule = shifts.allNext
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
